module.exports = __webpack_public_path__ + "img/logo-title.2e7bcb82.png";